import { useMemo } from "react";
import { ICodonMutation, IMutation, MutationLevelEnum } from "../types/mutation";
import codonToAminoAcid from "../../../data/codonToAminoAcid.json";

export function useCodonMutations(level: MutationLevelEnum, sequence: string, mutations: IMutation[] | null): ICodonMutation[] | null {
  return useMemo(() => {
    if (level !== MutationLevelEnum.DNA) return null;
    if (mutations === null) return null;

    // we suppose that positions are already ordered
    const codonMutations = mutations.reduce((result: ICodonMutation[], mutation: { position: number, units: string[] }) => {
      const lastCodon = result.length > 0 ? result[result.length - 1] : null;
      const firstPosOfCurrentCodon = firstPosOfCodon(mutation.position);
      const posInCodon = mutation.position - firstPosOfCurrentCodon;
      if (lastCodon !== null && lastCodon.positions[0] === firstPosOfCurrentCodon) {
        lastCodon.mutation.dna[posInCodon] = mutation.units[0];
      } else {
        const positions = Array.from({length: 3}, (_, i) => firstPosOfCurrentCodon + i);
        const wildTypeDna = positions.map(p => sequence[p-1]);
        const mutationDna = [...wildTypeDna];
        mutationDna[posInCodon] = mutation.units[0];
        result.push({
          positions: positions,
          wildType: {dna: wildTypeDna, aminoAcid: ""},
          mutation: {dna: mutationDna, aminoAcid: ""},
        });
      }
      return result;
    }, []);
    codonMutations.forEach(codon => {
      const wildTypeKey = codon.wildType.dna.join("");
      const mutationKey = codon.mutation.dna.join("");
      codon.wildType.aminoAcid = codonToAminoAcid.hasOwnProperty(wildTypeKey) ? codonToAminoAcid[wildTypeKey] : "X";
      codon.mutation.aminoAcid = codonToAminoAcid.hasOwnProperty(mutationKey) ? codonToAminoAcid[mutationKey] : "X";
    });
    return codonMutations;
  }, [level, sequence, mutations]);
}

function firstPosOfCodon(nucleotidePos: number) {
  return Math.floor((nucleotidePos - 1) / 3) * 3 + 1;
}